import { Component, inject, OnInit } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { KeycloakAuthService } from "@lib/auth/services/keycloak-auth.service";
import { ToastService } from "@lib/base/services/toast.service";
import { switchMap } from "rxjs";
import { BackendNotAvailableService } from "./backend-not-available.service";

const BLACK_LIST_ORIGIN: string[] = [
    "backend-not-available",
    "/backend-not-available",
];
const DEFAULT_ORIGIN = "/";

@Component({
    selector: "app-backend-not-available",
    imports: [
        MatButton,
        MatIconModule,
    ],
    templateUrl: "./backend-not-available.component.html",
    styleUrl: "./backend-not-available.component.scss",
})
export default class BackendNotAvailableComponent implements OnInit {
    private readonly authService = inject(KeycloakAuthService);
    private readonly backendNotAvailableService = inject(BackendNotAvailableService);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly toastService = inject(ToastService);

    private pathOrigin: string | null = null;

    ngOnInit() {
        this.pathOrigin = this.route.snapshot.queryParamMap.get("pathOrigin");
    }

    refresh() {
        this.backendNotAvailableService.testConnection().pipe(
            switchMap(() => {
                let origin = this.pathOrigin ?? DEFAULT_ORIGIN;
                if (BLACK_LIST_ORIGIN.includes(origin)) {
                    origin = DEFAULT_ORIGIN;
                }
                return this.router.navigate([origin]);
            }),
        ).subscribe({
            error: () => this.toastService.warning("Serveur non disponible, réessayez ultérieurement"),
        });
    }

    logout() {
        this.authService.logOut();
    }
}
